import moment from 'moment';

var beaver = require('beaver-logger');

var logger = beaver.Logger({
  // Url to send logs to
  url: 'https://log.boonproject.com',

  // Prefix to prepend to all events
  prefix: '',

  // Log level to display in the browser console
  logLevel: beaver.LOG_LEVEL.ERROR,

  // Interval to flush logs to server
  flushInterval: 6 * 1000,
});

const log = {
  username: 'Anonymous',
  sessionLoginTime: moment().format(),
  init: function (username) {
    this.username = username;
    this.sessionLoginTime = moment().format();
  },
  debug: function (event, data) {
    if (document.boonTesting) {
      console.debug(event, data);
    } else {
      console.debug(event, data);
      logger.debug(event, this.wrapData(data));
    }
  },
  warn: function (event, data) {
    if (document.boonTesting) {
      console.warn(event, data);
    } else {
      console.warn(event, data);
      logger.warn(event, this.wrapData(data));
    }
  },
  error: function (event, data) {
    if (document.boonTesting) {
      console.error(event, data);
    } else {
      console.error(event, data);
      logger.error(event, this.wrapData(data));
    }
  },
  info: function (event, data) {
    if (document.boonTesting) {
      console.info(event, data);
    } else {
      console.info(event, data);
      logger.info(event, this.wrapData(data));
    }
  },
  wrapData: function (data) {
    return Object.assign({ username: this.username, sessionLoginTime: this.sessionLoginTime }, data, {
      password: null,
    });
  },
};

export default log;



// WEBPACK FOOTER //
// ./src/logger/index.js